import { Box } from '@gemini/core';
import { TextArea } from '@gemini/ui';
import { IFieldProps } from '@mfe-types/field';

const TextAreaWrapper = ({ field, texts, styles }: Required<IFieldProps<any, any>>) => {
    return (
        <Box {...styles}>
            <TextArea {...field} isFullWidth label={texts.label ?? ''} testId={field.name} />
        </Box>
    );
};

export default TextAreaWrapper;
